import { render, staticRenderFns } from "./w-ctrl-video.vue?vue&type=template&id=c728de30&lang=pug&"
import script from "./w-ctrl-video.vue?vue&type=script&lang=js&"
export * from "./w-ctrl-video.vue?vue&type=script&lang=js&"
import style0 from "./w-ctrl-video.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c728de30')) {
      api.createRecord('c728de30', component.options)
    } else {
      api.reload('c728de30', component.options)
    }
    module.hot.accept("./w-ctrl-video.vue?vue&type=template&id=c728de30&lang=pug&", function () {
      api.rerender('c728de30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/widgets/w-ctrl-video.vue"
export default component.exports